export enum ModuleDisplayTypes {
  SLIDE_SHOW = 1,
  ROW_SLIDER = 2,
  GRID = 3,
  FEATURED = 4,
  LIST = 5,
  BANNER = 6,
  BLACK_FRIDAY_FEATURED = 7,
  BLACK_FRIDAY_ANIMATED_BAR = 8,
}

export enum ModuleRowTypes {
  LAST_PURCHASE = 1,
  CATEGORIES = 2,
  PRODUCTS = 3,
  PRODUCTS_CATEGORIES = 4,
  TEMPLATES = 5,
}
